// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__46l9q","title":"styles_title__93F1M"};